(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kids-shop-by-age"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-kids-age-tabs]').forEach((root) => {
      const tabs = [...root.querySelectorAll('[data-kids-age-tab]')];
      const panels = [...root.querySelectorAll('[data-kids-age-panel]')];
      if (!tabs.length || !panels.length) return;

      const activate = (index) => {
        tabs.forEach((tab, i) => {
          const isActive = i === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach((panel, i) => {
          const isActive = i === index;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));

        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            nextIndex = (index + 1) % tabs.length;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = tabs.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          tabs[nextIndex].focus();
          activate(nextIndex);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
